import { render, staticRenderFns } from "./parentLayout.vue?vue&type=template&id=39aee0b4&scoped=true"
import script from "./parentLayout.vue?vue&type=script&lang=js"
export * from "./parentLayout.vue?vue&type=script&lang=js"
import style0 from "./parentLayout.vue?vue&type=style&index=0&id=39aee0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aee0b4",
  null
  
)

export default component.exports